import {useCallback} from 'react'
import type {Maybe} from 'src/utils/Maybe'
import styled from 'styled-components'
import {Input} from '../form/Input'

interface DeliveryNoteProps {
  value: Maybe<string>
  setValue: (value: string) => void
}

const NoteWrapper = styled.div`
  margin-top: 16px;
  position: relative;
`
export const DeliveryNote = ({
  value,
  setValue,
}: DeliveryNoteProps): JSX.Element | null => {
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      setValue(event.target.value)
    },
    [setValue],
  )

  return (
    <NoteWrapper>
      <Input
        label="Athugasemd"
        withGutter
        onChange={handleChange}
        type="textarea"
        defaultValue={value ?? ''}
        valid
        maxLength={50}
        charCount={value?.length}
        showCharCount
      />
    </NoteWrapper>
  )
}
